<div class="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim-coupan dropdown-menu-top-unround dropdown-menu-lg d-none coupon_action_show" x-placement="top-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-240px, 50px, 0px);">
									<form>

										<!--begin: Head -->
										<div class="kt-head kt-head--skin-dark kt-head--fit-x kt-head--fit-b" style="background-image: url(./assets/image/bg-1.jpg)">
											<h3 class="kt-head__title">
												Coupon
											</h3>
										</div>

										<!--end: Head -->
										     <div class="tab-content px-1">
											     <div class="card col-lg-12 col-xl-12 my-1">
											      <div class="row">
											     	<div class="col-lg-2 col-xl-2 coupan_image" style="background-image:url(./assets/image/icons/coupon/discount_10.png)"></div>
											     	<div class="col-lg-7 col-xl-7">
											     		<small>On minimum purchase of $20</small>
											     		<br>
											     		<small>Code: DPCGEEk10</small>
											     		<br>
											     		<small>*Tax Extra</small>
											        </div>
											     	<div class="col-lg-2 col-xl-2 text-center mt-4"><a class="btn btn-light">Apply</a></div>
											      </div>
											     </div>
											     <div class="card col-lg-12 col-xl-12 my-1">
											      <div class="row">
											     	<div class="col-lg-2 col-xl-2 coupan_image" style="background-image:url(./assets/image/icons/coupon/discount_12.png)"></div>
											     	<div class="col-lg-7 col-xl-7">
											     		<small>On minimum purchase of $40</small>
											     		<br>
											     		<small>Code: DPCGEEk12</small>
											     		<br>
											     		<small>*Tax Extra</small>
											        </div>
											     	<div class="col-lg-2 col-xl-2 text-center mt-4"><a class="btn btn-light">Apply</a></div>
											      </div>
											     </div>
											     <div class="card col-lg-12 col-xl-12 my-1">
											      <div class="row">
											     	<div class="col-lg-2 col-xl-2 coupan_image" style="background-image:url(./assets/image/icons/coupon/discount_15.png)"></div>
											     	<div class="col-lg-7 col-xl-7">
											     		<small>On minimum purchase of $100</small>
											     		<br>
											     		<small>Code: DPCGEEk15</small>
											     		<br>
											     		<small>*Tax Extra</small>
											        </div>
											     	<div class="col-lg-2 col-xl-2 text-center mt-4"><a class="btn btn-light">Apply</a></div>
											      </div>
											     </div>
											     <div class="card col-lg-12 col-xl-12 my-1">
											      <div class="row">
											     	<div class="col-lg-2 col-xl-2 coupan_image" style="background-image:url(./assets/image/icons/coupon/discount_20.png)"></div>
											     	<div class="col-lg-7 col-xl-7">
											     		<small>On minimum purchase of $250</small>
											     		<br>
											     		<small>Code: DPCGEEk20</small>
											     		<br>
											     		<small>*Tax Extra</small>
											        </div>
											     	<div class="col-lg-2 col-xl-2 text-center mt-4"><a class="btn btn-light">Apply</a></div>
											      </div>
											     </div>
											 </div>
											</form>
										</div>